import { Button, LinearProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../../../../core/apiInstance";
import DataGridCustomToolbar from "../../../../components/DataGridCustomToolbar";
import QualityFeedbackModal from "../../Supply/QualityAnalysis/QualityFeedbackModal";
// import dayjs from "dayjs";
// import { dateFormat } from "../../../../core/constants";
// import DateModal from "../../Queries/QueryDetails/DateModal";

const OnHold = () => {
  const [data, setData] = useState([]);
  const [showQualityFeedbackModal, setShowQualityFeedbackModal] = useState({
    open: false,
    title: "",
    api: ""
  });
  const params = useParams();

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 200
    },
    {
      field: "rejected_from",
      headerName: "Rejected From",
      width: 150
    },
    {
      field: "rejected_reason",
      headerName: "Rejected Reason",
      width: 300
    },
    {
      field: "cancel",
      headerName: "CANCEL",
      width: 300,
      renderCell: (params) => {
        return (
          <Button
            disabled={params.row.logistics_type === "BULK" ? true : false}
            fullWidth
            color="primary"
            variant="outlined"
            component="label"
            onClick={() =>
              setShowQualityFeedbackModal({
                open: true,
                api: `/api/ppm/order-actions/object/${params.row.id}/cancel-order`,
                title: "CANCEL ORDER"
              })
            }>
            CANCEL
          </Button>
        );
      }
    }
  ];

  useEffect(() => {
    fetchDraftOrders();
  }, []);

  const fetchDraftOrders = async () => {
    console.log(params);
    const { orderId } = params;
    try {
      const response = await axiosInstance.get(
        `/api/ppm/projects-products-categories/object/${orderId}/orders?state=ON_HOLD`
      );
      setData(response.data);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="h-[calc(100vh-240px)]">
      <DataGrid
        rowSelection={false}
        rows={data}
        columns={columns}
        pageSizeOptions={[10, 50, 100]}
        disableMultipleColumnsSorting
        hideFooter
        disableColumnMenu
        slots={{
          toolbar: DataGridCustomToolbar,
          loadingOverlay: LinearProgress
        }}
      />
      {Boolean(showQualityFeedbackModal.open) && (
        <QualityFeedbackModal
          open={showQualityFeedbackModal.open}
          api={showQualityFeedbackModal.api}
          fetchParent={fetchDraftOrders}
          title={showQualityFeedbackModal.title}
          onClose={() =>
            setShowQualityFeedbackModal({
              open: false,
              title: "",
              api: ""
            })
          }
        />
      )}
    </div>
  );
};

export default OnHold;
